import React, { useState, useEffect } from "react";
import { API_ROUTE } from "../~api/apiRoutes";

import "./About.css"

const About = () => {

    const [feedbackEmail, setFeedbackEmail] = useState("");
    const [feedbackMessage, setFeedbackMessage] = useState("");

    const sendFeedback = async () => {        
        if (feedbackEmail != null && validateEmail(feedbackEmail) && feedbackMessage != null && feedbackMessage.length > 2) {
            await fetchFeedback();
        }
        else {
            alert("Fill all fields");
        }
    }

    const validateEmail = (email): boolean => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    }

    const fetchFeedback = async () => {
        let headers: Headers = new Headers();
        headers.set('Content-Type', 'application/json');
    
        let body = JSON.stringify({
          Email: feedbackEmail,
          FeedbackMessage: feedbackMessage
        });
        return await fetch(`${API_ROUTE}/gitlabreport/send-feedback`, {
          method: "POST",
          headers: headers,
          body
        })
          .then((res) => {alert("Thanks for the feedback")})
          .catch((err) => {
            console.error(err);
            alert("Error sending feedback");
          });
      }


    return (
        <>
            <div className="modal-content">
                <div className="readme-container">
                    <h1>Time Track Reporter</h1>

                    <p>
                        Welcome to <strong>TimeTrackReporter</strong> — a simple tool for generating
                        time tracking reports from systems like GitLab or Jira (and soon more).
                    </p>
                    <p>
                        The solution is based on the <a href='https://github.com/hvalovyura/TimeTrackReporterOS'>TimeTrackReporterOS</a>
                    </p>

                    <h2>🚀 What is this?</h2>
                    <p>
                        TimeTrackReporter helps teams and managers export <strong>time spent reports</strong> in a convenient <code>.csv</code> (with semicolon delimiter) or <code>.xlsx</code> format.
                    </p>

                    <p>Perfect for:</p>
                    <ul>
                        <li>project managers</li>
                        <li>team leads</li>
                        <li>outsourcing / billing</li>
                        <li>internal reporting</li>
                    </ul>

                    <h2>✨ Features</h2>
                    <ul>
                        <li>Export time tracking data to <code>.csv</code> (with semicolon delimiter) or <strong>Excel (.xlsx)</strong></li>
                        <li>Group by <strong>projects and employees</strong></li>
                        <li>Simple and fast — no setup required</li>
                        <li>Works with <strong>GitLab</strong> and <strong>Jira</strong> (more integrations coming soon)</li>
                    </ul>

                    <h2>📊 Supported systems</h2>
                    <ul>
                        <li>✅ GitLab</li>
                        <li>✅ Jira</li>
                        <li>⏳ Other systems (planned)</li>
                    </ul>

                    <h2>🛠 How to use</h2>
                    <ol>
                        <li>Enter your GitLab or Jira URL</li>
                        <li>For Jira: Provide your user Email</li>
                        <li>Provide your access token</li>
                        <li>Generate and download the report</li>
                    </ol>

                    <h2>🔒 Privacy & Security</h2>
                    <p>
                        We <strong>do NOT store</strong> your URL or access token.
                        All data is used only for generating the report.
                    </p>

                    <blockquote>
                        Note: Full authorization and encryption will be added in future versions.
                    </blockquote>

                    <h2>🗺 Roadmap</h2>
                    <ul>
                        <li>☐ UI improvements</li>
                        <li>☐ Charts</li>
                        <li>☐ Secure authentication</li>
                        <li>☐ Data encryption</li>
                        <li>☐ Scheduled reports</li>                        
                        <li>☐ And many many others</li>
                    </ul>
                </div>
                <div className="modal-footer">
                    <h2>📬 Contact</h2>
                    For feedback or questions:<br /><br />
                    <form id="contactForm">
                        <input 
                            type="email" 
                            placeholder="Your email" 
                            required 
                            onChange={(e) => setFeedbackEmail(e.target.value)}
                        />

                        <textarea 
                            placeholder="Your message..." 
                            rows={3}
                            required
                            onChange={(e) => setFeedbackMessage(e.target.value)}
                        ></textarea>

                        <button onClick={sendFeedback} type="button">Send</button>
                    </form>
                </div>                    
            </div>
        </>
    );
}

export default About;